<template lang="html">
  <div
    v-if="maxSpend > 0"
    class="points-redemption-input flex flex-col gap-2"
  >
    <div class="flex flex-wrap items-baseline justify-between gap-2">
      <div class="text-sm font-medium">
        Списать баллы
      </div>
      <div class="text-sm text-muted">
        Доступно: <span class="font-medium text-default">{{ $f.currency(walletBalance) }}</span>
      </div>
    </div>

    <div class="flex flex-wrap items-center gap-2">
      <UInput
        :model-value="draftValue"
        type="number"
        class="min-w-0 flex-1 max-sm:min-w-40"
        :min="0"
        :max="maxSpend"
        step="1"
        placeholder="0"
        :disabled="props.readonly"
        @update:model-value="handleInput"
        @focus="isFocused = true"
        @blur="handleBlur"
      />

      <UButton
        v-if="!props.readonly"
        variant="outline"
        color="neutral"
        :disabled="maxSpend <= 0"
        @click="applyMax"
      >
        Макс.
      </UButton>
    </div>

    <div class="text-xs text-muted">
      Можно списать до {{ $f.currency(maxSpend) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { maxPointsToSpend } from '../utils/clampPointsToSpend'

const props = withDefaults(defineProps<{
  modelValue: number
  walletBalance?: number
  maxPointsRedeemable?: number
  readonly?: boolean
}>(), {
  walletBalance: 0,
  maxPointsRedeemable: 0,
  readonly: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

const { $f } = useFormatter()

const maxSpend = computed(() =>
  maxPointsToSpend(props.walletBalance, props.maxPointsRedeemable),
)

const isFocused = ref(false)
const draftValue = ref(formatDraftValue(props.modelValue))

function formatDraftValue(value: number) {
  return String(value || 0)
}

watch(
  () => props.modelValue,
  (value) => {
    if (!isFocused.value) {
      draftValue.value = formatDraftValue(value)
    }
  },
)

function handleInput(raw: string | number) {
  const rawValue = typeof raw === 'number' ? String(raw) : raw
  draftValue.value = rawValue

  const parsed = Number.parseFloat(rawValue)
  const value = Number.isFinite(parsed) ? parsed : 0
  emit('update:modelValue', value)
}

function handleBlur() {
  isFocused.value = false
  draftValue.value = formatDraftValue(props.modelValue)
}

function applyMax() {
  emit('update:modelValue', maxSpend.value)
}
</script>
